/** How a screen reader should say an amount: "1,250 pesos and 50 centavos". */
export function spokenPeso(minor: number): string {
  const sign = minor < 0 ? 'minus ' : '';
  const abs = Math.abs(minor);
  const pesos = Math.floor(abs / 100);
  const cents = abs % 100;
  const pesoText = `${pesos.toLocaleString('en-US')} ${pesos === 1 ? 'peso' : 'pesos'}`;
  const centText = cents ? ` and ${cents} ${cents === 1 ? 'centavo' : 'centavos'}` : '';
  return `${sign}${pesoText}${centText}`;
}
